import {CellReference, RangeReference} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaASTNodes';
import {BaseFormulaVisitor} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaVisitor';
import {SlotGlobalKey, SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {area, mk} from '@mintdata/mint-kit/api/log/mk';

export class FindAllCellReferences extends BaseFormulaVisitor
{
    private _dependencies:Set<SlotGlobalKey> = new Set<SlotGlobalKey>();

    public cellReference(cellRef:CellReference)
    {
        this._dependencies.add(cellRef.globalKey);
    }

    public rangeReference(range:RangeReference)
    {
        const from = range.from as CellReference;
        const to = range.to as CellReference;
        const sheetId = from.sheetId;

        if( !from || !to )
        {
            mk.error(area.FormulaTouch, `Bad cell references: ${range.toString()}`);
            return;
        }

        if( !sheetId )
        {
            mk.error(area.FormulaTouch, `Cannot find sheetId in RangeReference: ${range.toString()}`);
            return;
        }

        const fromColIndex = Math.min(from.colIndex, to.colIndex);
        const toColIndex = Math.max(from.colIndex, to.colIndex);

        const fromRowIndex = Math.min(from.rowIndex, to.rowIndex);
        const toRowIndex = Math.max(from.rowIndex, to.rowIndex);

        for( let col = fromColIndex; col <= toColIndex; col++ )
        {
            for( let row = fromRowIndex; row <= toRowIndex; row++ )
            {
                this._dependencies.add(new SlotLocation(col, row).toGlobalKey(sheetId));
            }
        }
    }

    public getAllDependencies():Set<SlotGlobalKey>
    {
        return this._dependencies;
    }
}
